"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockApi3ReaderProxyV2__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "api3ServerV1_",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "dapiName_",
                type: "bytes32",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "target",
                type: "address",
            },
        ],
        name: "AddressEmptyCode",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "ERC1967InvalidImplementation",
        type: "error",
    },
    {
        inputs: [],
        name: "ERC1967NonPayable",
        type: "error",
    },
    {
        inputs: [],
        name: "FailedInnerCall",
        type: "error",
    },
    {
        inputs: [],
        name: "InvalidInitialization",
        type: "error",
    },
    {
        inputs: [],
        name: "NotInitializing",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "OwnableInvalidOwner",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "OwnableUnauthorizedAccount",
        type: "error",
    },
    {
        inputs: [],
        name: "UUPSUnauthorizedCallContext",
        type: "error",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "slot",
                type: "bytes32",
            },
        ],
        name: "UUPSUnsupportedProxiableUUID",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint64",
                name: "version",
                type: "uint64",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "UPGRADE_INTERFACE_VERSION",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "api3ServerV1",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "dapiName",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "initialOwner",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "read",
        outputs: [
            {
                internalType: "int224",
                name: "value",
                type: "int224",
            },
            {
                internalType: "uint32",
                name: "timestamp",
                type: "uint32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "data",
                type: "bytes",
            },
        ],
        name: "upgradeToAndCall",
        outputs: [],
        stateMutability: "payable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class MockApi3ReaderProxyV2__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(api3ServerV1_, dapiName_, overrides) {
        return super.getDeployTransaction(api3ServerV1_, dapiName_, overrides || {});
    }
    deploy(api3ServerV1_, dapiName_, overrides) {
        return super.deploy(api3ServerV1_, dapiName_, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.MockApi3ReaderProxyV2__factory = MockApi3ReaderProxyV2__factory;
//# sourceMappingURL=MockApi3ReaderProxyV2__factory.js.map